import { Button } from './Button';
import { downloadJson } from '../lib/exportJson';

interface ExportJsonButtonProps {
  /** Download filename — build it with `exportFilename(...)`. */
  filename: string;
  /** Envelope discriminator, e.g. "package-version" | "advisory" | "audit-report". */
  kind: string;
  /** The findings to export; serialized as the envelope's `data` field. */
  data: unknown;
  className?: string;
}

/** Secondary button that downloads the given findings as a JSON file. */
export function ExportJsonButton({ filename, kind, data, className }: ExportJsonButtonProps) {
  return (
    <Button
      type="button"
      variant="secondary"
      className={className}
      onClick={() => downloadJson(filename, kind, data)}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
      </svg>
      Export JSON
    </Button>
  );
}
